export default __webpack_public_path__ + "static/media/conventus-1.0c2f42bb.png";